import React, { useState, useEffect } from "react";
import { Modal, Button, Form, FloatingLabel } from "react-bootstrap";
import styles from "./stylesAdmin.module.css"
import { Inactivo } from "../../types/interfaces";
import { useLoading } from "../../components/LoadingContext";

interface EditInactivoModalProps {
  show: boolean;
  onHide: () => void;
  onEditItem: (item: Inactivo) => void;
  item: Inactivo;
  showNotification: (message: string, variant: "success" | "danger") => void;
}

export default function EditInactivoModal({
  show,
  onHide,
  onEditItem,
  item,
  showNotification,
}: EditInactivoModalProps) {
  const { setLoading } = useLoading();
  const [formData, setFormData] = useState<any>({});
  const [funcionario, setFuncionario] = useState<any>(null);
  const [emails, setEmails] = useState<any>({
    deBajaPor: "",
    // autorEstadoCorreo: "",
    // autorEstadoGde: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/inactivo/${item.id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
  
        const data = await response.json();
        setFormData(data.inactivo);
  
        const funcionarioResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/funcionarioInactive/${data.inactivo.funcionario_id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        });
        if (!funcionarioResponse.ok) {
          throw new Error("Failed to fetch funcionario data");
        }
  
        const funcionarioData = await funcionarioResponse.json();
        setFuncionario(funcionarioData);

        let deBajaPorEmail = "";
        // let autorEstadoCorreoEmail = "";
        // let autorEstadoGdeEmail = "";

        if (data.inactivo.deBajaPor) {
          const deBajaPorResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/usuario/${data.inactivo.deBajaPor}`, { method: "GET", headers: {"Content-Type": "application/json",}, credentials: "include" });
          if (deBajaPorResponse.ok) {
            const deBajaPorData = await deBajaPorResponse.json();
            deBajaPorEmail = deBajaPorData.email || "";
          }
        }

        // if (data.inactivo.autorEstadoCorreo) {
        //   const autorEstadoCorreoResponse = await fetch(
        //     `${process.env.REACT_APP_API_URL}/api/admin/usuario/${data.inactivo.autorEstadoCorreo}`
        //   );
        //   if (autorEstadoCorreoResponse.ok) {
        //     const autorEstadoCorreoData = await autorEstadoCorreoResponse.json();
        //     autorEstadoCorreoEmail = autorEstadoCorreoData.email || "";
        //   }
        // }

        // if (data.inactivo.autorEstadoGde) {
        //   const autorEstadoGdeResponse = await fetch(
        //     `${process.env.REACT_APP_API_URL}/api/admin/usuario/${data.inactivo.autorEstadoGde}`
        //   );
        //   if (autorEstadoGdeResponse.ok) {
        //     const autorEstadoGdeData = await autorEstadoGdeResponse.json();
        //     autorEstadoGdeEmail = autorEstadoGdeData.email || "";
        //   }
        // }
  
        setEmails({
          deBajaPor: deBajaPorEmail,
          // autorEstadoCorreo: autorEstadoCorreoEmail,
          // autorEstadoGde: autorEstadoGdeEmail
        });
  
      } catch (error) {
        console.error("Failed to fetch data:", error);
      } finally {
        setLoading(false);
      }
    };
  
    if (show && item.id) {
      fetchData();
    }
  }, [show, item.id, setLoading]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData: any) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prevData: any) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    setLoading(true);
    e.preventDefault();

    const transformedData = {
      ...formData,
      deBajaPor: emails.deBajaPor,
      autorEstadoCorreo: formData.autorEstadoCorreo,
      autorEstadoGde: formData.autorEstadoGde,
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/editInactivo/${item.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(transformedData),
        credentials: "include"
      });

      if (!response.ok) {
        throw new Error('Failed to edit inactivo');
      }

      showNotification("Inactivo editado con éxito", "success");
      setFormData({});
      onHide();
      onEditItem({ ...item, ...transformedData });
    } catch (error) {
      showNotification("Error al editar inactivo", "danger");
      console.error('Error editing inactivo gde:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} className={styles.modalContainer}>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton className={styles.modalHeader}>
          <Modal.Title>Editar Inactivo</Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.modalBody}>
          <FloatingLabel controlId="floatingInputFechaDeBaja" label="Fecha en que se pasó a inactivo" className="mb-3">
            <Form.Control type="text" placeholder="Fecha de baja" name="fechaDeBaja" value={formData.fechaDeBaja || ""} disabled />
          </FloatingLabel>

          <FloatingLabel controlId="floatingInputDeBajaPor" label="Quien lo pasó a inactivos" className="mb-3">
            <Form.Control type="text" placeholder="Quien lo paso a inactivos" name="deBajaPor" value={emails.deBajaPor || ""} disabled/>
          </FloatingLabel>

          <FloatingLabel controlId="floatingInputDisposicion" label="Dispo o Correo que dispone la baja" className="mb-3">
            <Form.Control type="text" placeholder="Disposición" name="disposicion" onChange={handleInputChange} value={formData.disposicion || ""} />
          </FloatingLabel>

          <FloatingLabel controlId="floatingInputFuncionario" label="Funcionario" className="mb-3">
            <Form.Control type="text" placeholder="Funcionario" name="funcionario" value={funcionario ? funcionario?.funcionario : ""} disabled />
          </FloatingLabel>

          <FloatingLabel controlId="floatingInputReparticionGde" label="Repartición GDE" className="mb-3">
            <Form.Control type="text" placeholder="Repartición GDE" name="reparticion_gde" value={funcionario ? funcionario?.reparticion_gde?.nombre : ""} disabled />
          </FloatingLabel>

          <FloatingLabel controlId="floatingInputSectorGde" label="Sector GDE" className="mb-3">
            <Form.Control type="text" placeholder="Sector GDE" name="sector_gde" value={funcionario ? funcionario?.sector_gde?.nombre : ""} disabled />
          </FloatingLabel>

          <FloatingLabel controlId="floatingInputRevista" label="Revista" className="mb-3">
            <Form.Control type="text" placeholder="Revista" name="revista" value={funcionario ? funcionario?.revista : ""} disabled />
          </FloatingLabel>

          <FloatingLabel controlId="floatingInputInterno" label="Interno" className="mb-3">
            <Form.Control type="text" placeholder="Interno" name="interno" value={funcionario ? funcionario?.interno : ""} disabled />
          </FloatingLabel>

          <FloatingLabel controlId="floatingInputEstablecimiento" label="Establecimiento" className="mb-3">
            <Form.Control type="text" placeholder="Establecimiento" name="establecimiento" value={funcionario ? funcionario?.establecimiento?.nombre : ""} disabled />
          </FloatingLabel>

          <FloatingLabel controlId="floatingInputUltimaUbi" label="Última ubicación" className="mb-3">
            <Form.Control type="text" placeholder="Última ubicación" name="ultimaUbi" onChange={handleInputChange} value={formData.ultimaUbi || ""} />
          </FloatingLabel>

          <FloatingLabel controlId="floatingInputCorreo" label="Correo" className="mb-3">
            <Form.Control type="text" placeholder="Correo" name="correo" value={funcionario ? funcionario?.correo : ""} disabled />
          </FloatingLabel>

          <FloatingLabel controlId="floatingInputEstadoCorreo" label="Estado del Correo" className="mb-3">
            <Form.Control type="text" placeholder="Estado del Correo" name="estadoCorreo" onChange={handleInputChange} value={formData.estadoCorreo || ""} />
          </FloatingLabel>

          <FloatingLabel controlId="floatingSelectEstadoCorreoPor" label="Quien dió de baja el Correo" className="mb-3">
            <Form.Select aria-label="Quien dió de baja el Correo" name="autorEstadoCorreo" onChange={handleSelectChange} value={formData.autorEstadoCorreo || ""}>
              <option value="" disabled>Seleccionar usuario</option>
                <option value='2'>marcelo.baldonedo@iosfa.gob.ar</option>
                <option value='3'>florencia.garrido@iosfa.gob.ar</option>
                <option value='4'>paula.salatino@iosfa.gob.ar</option>
                <option value='5'>zaiqi.zhou@iosfa.gob.ar</option>
            </Form.Select>
          </FloatingLabel>

          <FloatingLabel controlId="floatingInputUsuarioGde" label="Usuario GDE" className="mb-3">
            <Form.Control type="text" placeholder="Usuario GDE" name="usuario_gde" value={funcionario ? funcionario?.usuario_gde : ""} disabled />
          </FloatingLabel>

          <FloatingLabel controlId="floatingInputEstadoGde" label="Estado del GDE" className="mb-3">
            <Form.Control type="text" placeholder="Estado del GDE" name="estadoGde" onChange={handleInputChange} value={formData.estadoGde || ""} />
          </FloatingLabel>

          <FloatingLabel controlId="floatingSelectEstadoGdePor" label="Quien dió de baja el GDE" className="mb-3">
            <Form.Select aria-label="Quien dió de baja el GDE" name="autorEstadoGde" onChange={handleSelectChange} value={formData.autorEstadoGde || ""}>
              <option value="" disabled>Seleccionar usuario</option>
                <option value='2'>marcelo.baldonedo@iosfa.gob.ar</option>
                <option value='3'>florencia.garrido@iosfa.gob.ar</option>
                <option value='4'>paula.salatino@iosfa.gob.ar</option>
                <option value='5'>zaiqi.zhou@iosfa.gob.ar</option>
            </Form.Select>
          </FloatingLabel>

        </Modal.Body>
        <Modal.Footer className={styles.modalFooter}>
          <Button variant="warning" type="submit">Actualizar</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}